module.exports = __webpack_public_path__ + "static/media/star-success.54aecbc8.svg";